module.exports = __webpack_public_path__ + "static/media/MTL_ASC_MED2.e4070cf1.png";